import { Button, Grid } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { FreeTrialDialog } from 'components/shared/free-trial-dialog';
import { RichTextEditor } from 'components/shared/rich-text-editor';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { GetUrlBuilderData } from 'store/url-builder';
import style from './about-me.module.scss';
import { EditAboutMeDialog } from './edit-about-me-dialog';

export interface AboutMeProps {
    builderType: string;
    isFree?: boolean | null;
}


export const AboutMe = ({ builderType, isFree = null }: AboutMeProps) => {
    const [editAboutMeDialog, setEditAboutMeDialog] = useState(false);
    const [freeTrialDialog, setFreeTrialDialog] = useState(false);
    const builderData = useSelector(GetUrlBuilderData);

    const openEditAboutMeDialog = () => setEditAboutMeDialog(true);
    const handleEditAboutMeDialogClose = () => setEditAboutMeDialog(false);

    const openFreeTrialDialog = () => setFreeTrialDialog(true);
    const handleCloseFreeTrialDialog = () => setFreeTrialDialog(false);

    return (
        <Grid item container xs={12}>
            <Grid item xs={12} className='mb-3'>
                <Button onClick={!isFree ? openEditAboutMeDialog : openFreeTrialDialog} classes={{ root: style.root }} fullWidth>
                    <AddIcon /> <span style={{ marginTop: '3px' }}>{builderData.aboutMe.text ? "Add/Edit Text" : "Add Text"}</span>
                </Button>
            </Grid>
            {builderData.aboutMe.text && (
                <Grid item xs={12}>
                    <RichTextEditor initialState={builderData.aboutMe.text} readonly />
                </Grid>
            )}
            {editAboutMeDialog && <EditAboutMeDialog isOpen onClose={handleEditAboutMeDialogClose} builderType={builderType} />}
            {freeTrialDialog && <FreeTrialDialog isOpen={freeTrialDialog} onClose={handleCloseFreeTrialDialog} />}
        </Grid>
    );
};
